import React, { useState, useEffect } from "react";
import { List, Modal, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { DragHandle } from "../../../../components/DragHandle";
import axios from "axios";

const Ordering = ({
  isOpen,
  onClose,
  datas,
  moduleName,
  base_url,
  onUpdateOrder,
}) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDatalist([...datas]); 
    }
  }, [isOpen]);

  const handleOrder = async (updatedData) => {
    setLoading(true);

    const orderedFaqs = updatedData.map((item, index) => ({
      _id: item._id,
      position: index,
    }));

    try {
      const { data } = await axios.post(`${base_url}/reorder`, {
        order: orderedFaqs,
      });

      notification.success({
        message: `${moduleName} order updated successfully!`,
      });

      // Update parent component's state so table reflects new order
      if (onUpdateOrder) {
        onUpdateOrder(data); // keep the order as returned from API
      }

      onClose();
    } catch (err) {
      console.error(err);
      notification.error({ message: `Failed to update ${moduleName} order` });
    }

    setLoading(false);
  };

  return (
    <Modal
      title={`${moduleName} Ordering`}
      visible={isOpen}
      onOk={() => handleOrder(datalist)}
      okText="Update"
      confirmLoading={loading}
      onCancel={onClose}
    >
      <DragDropContext
        onDragEnd={(param) => {
          const srcIndex = param.source.index;
          const destIndex = param.destination?.index;

          if (destIndex !== undefined) {
            const tempArray = [...datalist];
            tempArray.splice(destIndex, 0, tempArray.splice(srcIndex, 1)[0]);
            setDatalist(tempArray);
          }
        }}
      >
        <Droppable droppableId="droppable-faqs">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <List
                bordered
                dataSource={datalist}
                renderItem={(item, index) => (
                  <Draggable
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <List.Item
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging
                            ? "0 0 .4rem #666"
                            : "none",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span>{item.question}</span>
                        <DragHandle {...provided.dragHandleProps} />
                      </List.Item>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default Ordering;
